import { useEffect, useState } from "react"

// Vendored default was 768; aligned to the 900px design breakpoint the rest
// of the shell uses (App.css .main media query) — <=900 is "mobile".
const MOBILE_BREAKPOINT = 901

export function useIsMobile() {
  // Local change: initialize synchronously — starting undefined (coerced to
  // desktop) made 768-900px loads flash the desktop column before the
  // mount effect flipped to the drawer.
  const [isMobile, setIsMobile] = useState<boolean>(
    () => window.innerWidth < MOBILE_BREAKPOINT
  )

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}
